<div class="proc-download">
  <div class="proc-download__header">
    <h1 class="proc-download__header-text">Download Procedures</h1>
    <div class="proc-download__header-actions">
      <button type="button" (click)="closeDialog()" mat-icon-button class="proc-download__close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="proc-download__body">
    <p class="proc-download__description">
      Use the form below to download terminal procedures for your favorite airports.
    </p>
    <app-state-view [promise]="procsPromise">
      <loading-state>
        <div class="proc-download__loader">
          <mat-spinner diameter="18" class="proc-download__spinner"></mat-spinner>
          <div class="proc-download__loader-message">
            Loading Procedures...
          </div>
        </div>
      </loading-state>
      <content-state>
        <div class="proc-download__field">
          <label for="proc-format" class="proc-download__field-label">Format:</label>
          <div class="proc-download__field-value">
            <mat-button-toggle-group id="proc-format" [(ngModel)]="format" cdkFocusInitial>
              <mat-button-toggle [value]="TerminalProcedureBatchFormat.PDF">Single PDF</mat-button-toggle>
              <mat-button-toggle [value]="TerminalProcedureBatchFormat.ZIP">ZIP</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
        <div class="proc-download__field">
          <label for="proc-cycle" class="proc-download__field-label">Data Cycle:</label>
          <div class="proc-download__field-value">
            <div class="proc-download__cycle">
              <mat-button-toggle-group id="proc-cycle" [(ngModel)]="cycle" class="proc-download__cycle-btn-group">
                <mat-button-toggle [value]="TerminalProcedureCycle.Current">Current</mat-button-toggle>
                <mat-button-toggle [value]="TerminalProcedureCycle.Next">Upcoming</mat-button-toggle>
              </mat-button-toggle-group>
              <span *ngIf="effectiveDate" class="proc-download__cycle-eff-date">
                Effective: {{ effectiveDate | date: 'mediumDate' }}
              </span>
            </div>
            <mat-checkbox [(ngModel)]="changedOnly" class="proc-download__changed-chk">
              Only include changed files
            </mat-checkbox>
          </div>
        </div>
        <div class="proc-download__field">
          <label for="proc-docs" class="proc-download__field-label">Documents:</label>
          <div class="proc-download__field-value">
            <app-proc-selection-tree
              *ngIf="procedures && procedures.length" [airports]="airports" [procedures]="procedures"
              (selectionChanged)="onSelectionChanged($event)">
            </app-proc-selection-tree>
            <div *ngIf="!procedures || procedures.length < 1" class="proc-download__placeholder">
              <mat-icon class="proc-download__placeholder-icon">info</mat-icon>
              <div class="proc-download__placeholder-message">{{ placeholderMessage }}</div>
            </div>
          </div>
        </div>
        <div *ngIf="deletedProcedures.length > 0" class="proc-download__field proc-download__field--warning">
          <span class="proc-download__field-label">Deleted Procedures:</span>
          <div class="proc-download__field-value">
            <div class="proc-download__deleted-procs">
              <div class="proc-download__deleted-procs-header">
                Some of the airports in your favorites have terminal procedures that have been recently removed.
                The following terminal procedures should no longer be used:
              </div>
              <div class="proc-download__deleted-procs-body">
                <div *ngFor="let procedure of deletedProcedures" class="proc-download__deleted-proc">
                  {{ getAirportIdentifier(procedure.airportId) }}: {{ procedure.name }} ({{ formatProcType(procedure.type) }})
                </div>
              </div>
            </div>
          </div>
        </div>
      </content-state>
      <error-state>
        <div class="proc-download__placeholder proc-download__placeholder--error">
          <mat-icon class="proc-download__placeholder-icon">warning</mat-icon>
          <div class="proc-download__placeholder-message">
            An error occurred loading terminal procedures. Please try again later.
          </div>
        </div>
      </error-state>
    </app-state-view>
  </div>
  <div class="proc-download__footer">
    <div *ngIf="numSelected !== null" class="proc-download__summary">
      <div class="proc-download__summary-field">
        <span class="proc-download__summary-label">Number of documents:</span>
        <span class="proc-download__summary-value">{{ numSelected }}</span>
      </div>
      <div class="proc-download__summary-field">
        <span class="proc-download__summary-label">Total size (uncompressed):</span>
        <span class="proc-download__summary-value">{{ totalSizeStr }}</span>
      </div>
    </div>
    <div *ngIf="procedureData && message" class="proc-download__message">
      <mat-icon class="proc-download__message-icon">warning</mat-icon>
      <div class="proc-download__message-text">{{ message }}</div>
    </div>
    <div class="proc-download__actions">
      <button type="button" [disabled]="downloadDisabled" (click)="download()" mat-button
              class="aopa-mat-btn aopa-mat-btn--filled proc-download__download-btn">
        Download
      </button>
      <button type="button" (click)="closeDialog()" mat-button class="aopa-mat-btn aopa-mat-btn--secondary">Cancel</button>
    </div>
  </div>
</div>
